import { REQUIRED_ERROR } from "./errorFieldValues";

export const ACCRUAL_PERIOD_DATE = "date";
export const ACCRUAL_PERIOD_WEEK = "week";
export const ACCRUAL_PERIOD_MONTH = "month";
export const ACCRUAL_PERIOD_YEAR = "year";

export const accrualPeriodTypes = [
    {
        label: "Произвольные дни",
        value: ACCRUAL_PERIOD_DATE,
    },
    {
        label: "Каждую неделю",
        value: ACCRUAL_PERIOD_WEEK,
    },
    {
        label: "Каждый месяц",
        value: ACCRUAL_PERIOD_MONTH,
    },
    {
        label: "Каждый год",
        value: ACCRUAL_PERIOD_YEAR,
    },
];

export const accrualPeriodErrors = {
    [ACCRUAL_PERIOD_DATE]: REQUIRED_ERROR,
    [ACCRUAL_PERIOD_WEEK]: "Необходимо выбрать хотя бы один день недели",
    [ACCRUAL_PERIOD_MONTH]: REQUIRED_ERROR,
    [ACCRUAL_PERIOD_YEAR]: REQUIRED_ERROR,
};
